<template>
  <el-select class="td_select"
             v-model="values"
             default-first-option
             filterable
             remote
             reserve-keyword
             allow-create
             placeholder="请输入项目名称"
             :clearable="clearable"
             :disabled="disabled"
             :remote-method="remoteMethod"
             @change="change"
             @clear="clearAction"
             :loading="loading">
    <el-option
        class="td_option"
        v-for="(item, index) in options"
        :key="index"
        :label="item.projectName"
        :value="item.projectName"
        @click.native="handleSelect(item)">
      <!--      <span style="float: left;width: 130px;"><i class="fa fa-gg-circle" :style="{'color':'#f78989','margin-right': '5px'}"></i>{{ item.customerNo }}</span>-->
      <!--      <span style="float: left; color: #8492a6; font-size: 13px;">{{ item.customerName }}</span>-->
      <!--      <span style="float: left">{{ item.mdmCode }}</span>-->
      <!--      <span style="float: left; margin-left: 20px; color: #8492a6; font-size: 13px">{{ item.customerName }}</span>-->
    </el-option>
  </el-select>
</template>
<script>

import { validatenull } from '@/tdcommon/validate'
// import { cusName } from '@/api/basic/customer'
import { getIntroduceProject } from '@/api/basic/introduce'
// 成本询价 项目名称 查询条件
export default {
  name: 'd2-container-introduce-project-search',
  data () {
    return {
      values: this.value,
      options: [],
      loading: false
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    url: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    remoteMethod (query) {
      this.loading = true
      var searchQuery = validatenull(query) ? '' : query
      getIntroduceProject(searchQuery).then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    change (val) {
      console.log('询价change', val)
      this.$emit('change', val)
    },
    handleSelect (val) {
      console.log('询价handleSelect', val)
      this.$emit('clickSelect', val)
    },
    clearAction () {
      this.$emit('change', '')
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val)
    },
    value: function (val, oldVal) {
      this.remoteMethod(val)
      this.values = val
    }
  },
  mounted () {
    this.remoteMethod(this.value)
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-introduce-project-search/index.vue"
}
</vue-filename-injector>
